import { Map } from 'immutable';

import { aiGeneratedAltText } from './ai';
import { getAIOperation } from '../../ai';
import { isObject } from '../../../isObject';

import { AI_OPERATION } from '../../../../constants/ai';
import { OPERATIONS } from '../../../../constants/bulkEdit';
import { ATTRIBUTE } from '../../../../constants/attributes';
import { SHOPIFY } from '../../../../constants/channels';
import { EMPTY } from '../../../../constants';

export function photos({ channel, operation, preview, state }) {
  function reduceValue(result, value) {
    return result.push(
      isObject(value) && !Map.isMap(value)
        ? Map(value)
        : value
    );
  }

  switch (operation) {
    case OPERATIONS[channel].PHOTOS.ADD: {
      return {
        payload: Map({
          type: operation,
          value: preview.getIn([ATTRIBUTE.PHOTOS, ATTRIBUTE.PHOTOS]).reduce(reduceValue, EMPTY.LIST),
        }),
      };
    }

    case OPERATIONS[channel].PHOTOS.DELETE: {
      const payload = [
        Map({ type: operation, value: preview.getIn([ATTRIBUTE.PHOTOS, ATTRIBUTE.PHOTOS]) }),
      ];

      if (
        channel === SHOPIFY &&
        preview.getIn([ATTRIBUTE.PHOTOS, ATTRIBUTE.PHOTOS, 0])
      ) {
        const keywordsOperation = getAIOperation({
          channel,
          value: { destination: 'keywords', operation: AI_OPERATION.GENERATE },
        });

        payload.push(keywordsOperation);
      }

      return { payload };
    }

    case OPERATIONS[channel].PHOTOS.REPLACE: {
      const payload = [
        Map({
          type: operation,
          value: preview.getIn([ATTRIBUTE.PHOTOS, ATTRIBUTE.PHOTOS]).reduce(reduceValue, EMPTY.LIST),
        }),
      ];

      if (
        channel === SHOPIFY &&
        preview.getIn([ATTRIBUTE.PHOTOS, ATTRIBUTE.PHOTOS, 0, 'alt_text'])
      ) {
        const keywordsOperation = getAIOperation({
          channel,
          value: { destination: 'keywords', operation: AI_OPERATION.GENERATE },
        });

        payload.push(keywordsOperation);
      }

      return { payload };
    }

    case OPERATIONS[channel].PHOTOS.ALT_TEXT: {
      const payload = [
        Map({
          type: OPERATIONS[channel].PHOTOS.UPDATE,
          value: Map({
            attributes: Map({ alt_text: preview.getIn([ATTRIBUTE.PHOTOS, 'value'], '') }),
            index: preview.getIn([ATTRIBUTE.PHOTOS, 'photo']),
          }),
        }),
      ];

      if (
        channel === SHOPIFY &&
        preview.getIn([ATTRIBUTE.PHOTOS, 'value']) &&
        preview.getIn([ATTRIBUTE.PHOTOS, 'photo']) === 0
      ) {
        const keywordsOperation = getAIOperation({
          channel,
          value: { destination: 'keywords', operation: AI_OPERATION.GENERATE },
        });

        payload.push(keywordsOperation);
      }

      return { payload };
    }

    case OPERATIONS[channel].PHOTOS.ALT_TEXT_AI_GENERATED: {
      const { edited, payload, preview: updatedPreview } = aiGeneratedAltText({ channel, preview, state });

      if (
        channel === SHOPIFY &&
        preview.hasIn([ATTRIBUTE.PHOTOS, 'indexes', 0])
      ) {
        const keywordsOperation = getAIOperation({
          channel,
          products: edited.toList(),
          value: { destination: 'keywords', operation: AI_OPERATION.GENERATE },
        });

        return { edited, payload: payload.push(keywordsOperation), preview: updatedPreview };
      }

      return { edited, payload, preview: updatedPreview };
    }

    default: {
      return { payload: [] };
    }
  }
}
